import {
  buildSpellCastRequest,
  quoteSpellCast,
} from './spellCastEngine';

export function buildSpellCastInfoRequest({
  ...options
} = {}) {
  return buildSpellCastRequest(options);
}

export function getSurfaceSpellCastInfo(options = {}) {
  return quoteSpellCast(buildSpellCastInfoRequest(options));
}

export function formatSpellCastInfoLabel(info, spell = {}) {
  if (!info) return '';
  if (info.displayMode === 'system-tiered') {
    return spell.level === 0 ? '∞' : `${info.slotsRemaining} slot${info.cost > 1 ? ` (${info.cost})` : ''}`;
  }
  if (info.displayMode === 'legacy-slots') {
    return spell.level === 0 ? '∞' : `${info.slotsRemaining} slots`;
  }
  if (spell.level === 0) return '∞';
  if (info.freeAvailable) return 'FREE';

  const suffix = info.displayMode === 'system-scalar'
    ? (info.resourceLabel || 'Resource')
    : 'MP';

  return info.overcast ? `${info.cost}⚡` : `${info.cost} ${suffix}`;
}

export function isSpellCastInfoBlocked(info, { isDM = false } = {}) {
  if (!info) return true;
  if (info.tooHigh) return true;
  return isDM ? false : !info.canCast;
}

export function getSpellCastLevelOptions({ spell, getCastInfo }) {
  const baseInfo = getCastInfo?.(spell, spell?.level || 0);
  return baseInfo?.availableCastLevels?.length > 0
    ? baseInfo.availableCastLevels
    : [spell?.level || 0];
}

export function resolveSelectedSpellCastLevel({ spell, preferredLevel = null, getCastInfo }) {
  const levelOptions = getSpellCastLevelOptions({ spell, getCastInfo });
  if (levelOptions.length === 0) {
    return spell?.level || 0;
  }
  if (Number.isFinite(preferredLevel) && levelOptions.includes(preferredLevel)) {
    return preferredLevel;
  }
  return levelOptions[0];
}

export function shiftSelectedSpellCastLevel({ spell, currentLevel, direction, getCastInfo }) {
  const levelOptions = getSpellCastLevelOptions({ spell, getCastInfo });
  if (levelOptions.length === 0) {
    return spell?.level || 0;
  }
  const resolvedLevel = resolveSelectedSpellCastLevel({ spell, preferredLevel: currentLevel, getCastInfo });
  const currentIndex = Math.max(0, levelOptions.indexOf(resolvedLevel));
  const nextIndex = Math.max(0, Math.min(levelOptions.length - 1, currentIndex + direction));
  return levelOptions[nextIndex] ?? resolvedLevel;
}
